module.exports = __webpack_public_path__ + "img/pdf-file.28a677bd.svg";